import React from 'react'

import './Nav.css'
import Miniature from './Miniature'

import './AdminVideo.css'

import {Link} from 'react-router-dom'

export const AdminVideo = ({stateMytube,videoSelected,handleVue,state,isAlreadyLike,refCard}) => {

    //valeur des tag 1=>nature 2=>musique  3=>dessin

    const addVue=(value)=>{
        handleVue(value)
    }

    const selecedVideo2= {videoSelected}

    const allVideo=
    Object.keys(stateMytube || {})
                .map(items =>
                {
                    let test=''
                    const path=`videoSelect/${items}`
                    
                    if(videoSelected!==null && videoSelected!==undefined) // si on recherche une video en particulier
                    {
                        if(videoSelected===items)
                        {
                           test= 
                            <Link key={'..'+path}  style={{textDecoration:'none',color:'#000'}} to={'../'+path} >
                                <Miniature 
                                    key={items} 
                                    id={items}
                                    auteur={stateMytube[items].auteur}
                                    name={stateMytube[items].nom}
                                    url={stateMytube[items].url}
                                    tag={stateMytube[items].tag}
                                    vue={stateMytube[items].vue}
                                    like={stateMytube[items].like}
                                    isAlreadyLike={isAlreadyLike}
                                    addVue={addVue}
                                />
                            </Link>
                        }
                    }
                    else  // on cherche à afficher toute les viedos (accueil)
                    {
                            test=
                                <Link key={path}  style={{textDecoration:'none',color:'#000'}}
                                    to={path} >
                                    <Miniature 
                                        key={items} 
                                        id={items}
                                        auteur={stateMytube[items].auteur}
                                        name={stateMytube[items].nom}
                                        url={stateMytube[items].url}
                                        tag={stateMytube[items].tag}
                                        vue={stateMytube[items].vue}
                                        like={stateMytube[items].like}
                                        isAlreadyLike={isAlreadyLike}
                                        addVue={addVue}
                                    />
                                </Link>
                     }
                    return test
                })
   
    return (
        <div className="cards" ref={refCard}>
         {allVideo}
       </div>
    )
}
export default AdminVideo
